<template>
  <div class="packageMypage">
    <div class="title">{{ `${locale.ticket} & ${locale.mypackage_history}` }}</div>
    <ul class="mypageList">
      <li v-for="(property, index) in mypageProperties"
        :key="index"
        class="item">
        <router-link
          :key="property.id"
          :to="{name: property.routerName, params: { ...$route.params, package: 'package' }}"
          :class="property.className"
          class="item horizontal">
          {{locale[property.name]}}
          <span class="count">{{ property.count || 0 }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'PackageMypage',
  props: [
    'locale',
    'mypageTypes'
  ],
  computed: {
    mypageProperties () {
      const mypageTypes = this.mypageTypes
      const getPropertyName = (property) => {
        const list = /order|payment|reservation|ticket/
        const my = /mobility/
        let name = property
        if (list.test(property)) {
          name = `${property}_list`
        } else if (my.test(property)) {
          name = `${property}_my`
        }
        return name
      }
      const getRouterName = (property) => {
        const my = /order|payment|reservation|mobility|ticket/
        let name = property
        if (my.test(property)) {
          name = `my${toCapitalized(property)}`
        }
        return name
      }
      function toCapitalized (str) {
        return regExp.toCapitalized(str)
      }

      // path: '/:ln/myReservation/package?',
      return mypageTypes.map(x => {
        return {
          id: x.pageType,
          name: getPropertyName(x.pageType),
          routerName: getRouterName(x.pageType),
          routerPath: `${getRouterName(x.pageType)}/package`,
          count: x.count
        }
      })
    }
  },
  methods: {
  }
}
</script>
